import { store } from '@/store';
/* The interface to disable/enable automation is in the console, rather than via query parameters for
 * the following reasons:
 *   a) To avoid interfering with PVE, which 'takes ownership' of the query parameters;
 *   b) To have a chance of working in the PWA world, where there aren't any query parameters!
 *
 * Please see guest-app/private/docs/Automation.md for usage information.
 */

var automation = {
  enable: function enable() {
    var _enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    store.commit('config/configureAutomation', _enable); // Most automation won't be available until the page refreshes, so do it, but provide the ability
    // to not do it if the automation runner wants to take control.

    if (reload) {
      window.location.reload();
    }
  },
  isEnabled: function isEnabled() {
    return store.getters['config/automationEnabled'];
  }
};
/*
 * We only provide access to the automation tools if the app is configured to allow them to be used.
 *   We *don't* want to always have the automation tools in place so that TST stays in parity
 * with the behaviour on PRD.
 */

window.fibAutomation = process.env.ALLOW_AUTOMATION ? automation : null;